// extracted by mini-css-extract-plugin
export default {"pageNavigation":"Pagination_pageNavigation__nPsVz","navigationButton":"Pagination_navigationButton__cqFzy","disabledButton":"Pagination_disabledButton__D2UUt"};